import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { Permission } from './types';

const UNCONDITIONALLY_ALLOWED_PERMISSIONS_BY_ENTITY: Partial<
  Record<Entities, Permission[]>
> = {
  [Entities.checkList]: ['canAdd', 'canEdit', 'canDelete'],
  [Entities.webShopDefinition]: ['canAdd', 'canEdit'],
  [Entities.lookUp]: ['canAdd', 'canEdit', 'canDelete'],
  [Entities.ticketCategory1]: ['canAdd', 'canEdit', 'canDelete'],
  [Entities.topic]: ['canAdd', 'canEdit', 'canDelete'],
  [Entities.ticketKind]: ['canAdd', 'canEdit', 'canDelete'],
};

type Props = {
  entity: Entities;
  permission: Permission;
};

export const isPermissionUnconditionallyAllowed = ({
  entity,
  permission,
}: Props): boolean => {
  return (UNCONDITIONALLY_ALLOWED_PERMISSIONS_BY_ENTITY[entity] ?? []).includes(
    permission
  );
};
